import React from "react";
import { Typography, Switch, Button } from "@mui/material";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-js-extras";
import * as LucideIcons from "lucide-react";
const CodePreviewPanel = ({
 error,
 retryCountRef,
 MAX_RETRIES,
 addedLibraryUrl,
 themeColor,
 profJimBrandColors,
 activePreview,
 setActivePreview,
 activeTabValue,
 generatedJSX,
 isEmbed,
 isAddingToLibrary,
 handleAddNewGameToLibrary,
 handleGeneratedCodeChange,
 isProcessing,
 renderGamePreview,
 codeFromUrl,
 isEditMode,
 enableCodeValidation,
 onManualPreviewUpdate,
 hasCodeBeenEdited,
 showPreviewUpdateSuccess,
 isCurrentCodePreviewed,
 hidePublicURLButton
}) => {
  return (
    <div style={{ width: "100%" }}>
      {error && (
        <div
          style={{
            color: "red",
            marginTop: "0px",
            width: "100%",
            marginBottom: "10px",
            display: "flex",
            fontFamily: themeColor.primaryFont,
          }}
        >
          {retryCountRef.current < MAX_RETRIES ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              {error}
              <LucideIcons.Loader
                size={16}
                className="animate-spin"
                style={{ marginLeft: "10px" }}
              />
            </div>
          ) : (
            <>
              <LucideIcons.Ban
                style={{
                  marginRight: "10px",
                  minWidth: "20px",
                  width: "20px",
                  height: "20px",
                }}
              />
              {error}
            </>
          )}
        </div>
      )}
      {addedLibraryUrl && (
       <div
         style={{
           color: "green",
           marginTop: "0px",
           fontFamily: "Poppins",
           fontSize: "15px",
           display: "flex",
           marginBottom: "10px",
         }}
       >
         <strong style={{ marginRight: "20px" }}>URL: </strong>
         <span>{addedLibraryUrl}</span>
       </div>
     )}
     {showPreviewUpdateSuccess && (
       <div
         style={{
           color: "green",
           marginTop: "0px",
           width: "100%",
           marginBottom: "10px",
           display: "flex",
           alignItems: "center",
           fontFamily: themeColor.primaryFont,
         }}
       >
         <LucideIcons.CheckCircle
           size={16}
           style={{ marginRight: "8px" }}
         />
         Preview has been updated! Switch to the Preview tab to see your changes.
       </div>
     )}
      <div
       style={{
         width: "100%",
         height: "40px",
         display: "flex",
         backgroundColor: themeColor.previewbackgroundColor,
         padding: "5px 20px",
         alignItems: "center",
         justifyContent: "space-between",
         gap: "20px",
       }}
     >
       <div
         style={{
           width: "100%",
           display: "flex",
           alignItems: "center",
         }}
       >
         <Typography
           variant="h5"
           color={profJimBrandColors.white}
           sx={{
             fontWeight: "bold",
             fontSize: "14px",
             fontFamily: themeColor.primaryFont,
           }}
         >
           Preview
         </Typography>
         <Switch
           checked={activePreview === activeTabValue.code}
           onChange={(e) => {
             setActivePreview(e.target.checked ? activeTabValue.code : activeTabValue.preview);
           }}
           sx={{
             "& .Mui-checked+.MuiSwitch-track": {
               backgroundColor: profJimBrandColors.white + "!important",
             },
             "& .MuiSwitch-track": {
               backgroundColor: profJimBrandColors.white + "!important",
             },
             "& .MuiSwitch-thumb": {
               backgroundColor: profJimBrandColors.white,
             },
           }}
         />
         <Typography
           variant="h5"
           color={profJimBrandColors.white}
           sx={{
             fontWeight: "bold",
             fontSize: "14px",
             fontFamily: themeColor.primaryFont,
           }}
         >
           Code
         </Typography>
       </div>
       <div style={{ display: "flex", alignItems: "center" }}>
         {generatedJSX && !enableCodeValidation && activePreview === activeTabValue.code && hasCodeBeenEdited && (
           <Button
             size="small"
             sx={{
               backgroundColor: themeColor.urlButtonColor
                 ? themeColor.urlButtonColor
                 : themeColor.instructionColor,
               textTransform: "none",
               borderRadius: "18px",
               minWidth: "180px",
               marginTop: "3px",
               marginRight: "20px",
               fontFamily: themeColor.primaryFont,
               '&.Mui-disabled': {
                 backgroundColor: 'rgba(255, 255, 255, 0.3)',
                 color: '#2C3E50',
                 cursor: 'not-allowed'
               }
             }}
             variant="contained"
             disabled={isProcessing || isCurrentCodePreviewed}
             onClick={onManualPreviewUpdate}
           >
             {showPreviewUpdateSuccess ? "Preview updated!" : "Update preview"}
           </Button>
         )}
         
         {generatedJSX && (
           <>
             {isEmbed === "true" && codeFromUrl === null && (
               <Button
                 size="small"
                 sx={{
                   backgroundColor: themeColor.urlButtonColor
                     ? themeColor.urlButtonColor
                     : themeColor.instructionColor,
                   textTransform: "none",
                   borderRadius: "18px",
                   minWidth: "180px",
                   marginTop: "3px",
                   marginRight: "20px",
                   fontFamily: themeColor.primaryFont,
                   '&.Mui-disabled': {
                      backgroundColor: 'rgba(255, 255, 255, 0.3)',
                      color: '#2C3E50',
                      cursor: 'not-allowed'
                    }
                  }}
                  variant="contained"
                  disabled={isAddingToLibrary || isProcessing}
                  onClick={() => handleAddNewGameToLibrary(false)}
                >
                  {isAddingToLibrary
                    ? "Working on it..."
                    : isEditMode
                      ? "Save Changes"
                      : "Add to Content"
                  }
                </Button>
              )}
              <Button
                size="small"
                sx={{
                  backgroundColor: themeColor.urlButtonColor
                    ? themeColor.urlButtonColor
                    : themeColor.instructionColor,
                  textTransform: "none",
                  borderRadius: "18px",
                  minWidth: "180px",
                  marginTop: "3px",
                  display: hidePublicURLButton ? "none" : "",
                  fontFamily: themeColor.primaryFont,
                  '&.Mui-disabled': {
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    color: '#2C3E50',
                    cursor: 'not-allowed'
                  }
                }}
                variant="contained"
                disabled={isAddingToLibrary || isProcessing}
                onClick={() => handleAddNewGameToLibrary()}
              >
                {isAddingToLibrary ? "Working on it..." : "Get public URL"}
              </Button>
            </>
          )}
        </div>
      </div>
      <div
        style={{
          minHeight: "400px",
          width: "100%",
          maxHeight: isEmbed === "true" ? "70vh" : "90vh",
          overflow: isEmbed === "true" ? "auto" : "auto",
          border: "2px solid " + profJimBrandColors.grey,
        }}
      >
        <div
          id="code-container"
          style={{
            overflow: "auto",
            display: activePreview === activeTabValue.code ? "" : "none",
          }}
        >
          <Editor
            placeholder="Watch your interactive element come to life through code!"
            value={generatedJSX}
            onValueChange={handleGeneratedCodeChange}
            highlight={(code) => highlight(code, languages.js)}
            padding={10}
            disabled={isProcessing}
            style={{
              fontFamily: '"Fira code", "Fira Mono", monospace',
              fontSize: 12,
              minHeight: "400px",
              outline: "none",
              border: "none",
              cursor: isProcessing ? "not-allowed" : "text",
            }}
          />
        </div>
        {renderGamePreview()}
      </div>
    </div>
  );
};

export default CodePreviewPanel;
